module.exports = __webpack_public_path__ + "img/Dantam Fashion 08.d75501d5.jpg";